export const OPEN_TEXT_MODAL = 'OPEN_TEXT_MODAL'

export const CLOSE_MODAL = 'CLOSE_MODAL'
export const OPEN_CUSTOM_MODAL = 'OPEN_CUSTOM_MODAL';
export const OPEN_SMALL_CUSTOM_MODAL = 'OPEN_SMALL_CUSTOM_MODAL';


export const CLOSE_IMAGE_MODAL = 'CLOSE_IMAGE_MODAL';
export const OPEN_CUSTOM_IMAGE_MODAL = 'OPEN_CUSTOM_IMAGE_MODAL';


